import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface NavigationState {
  isMobile: boolean;
  isCollapsed: boolean;
  activePage: string;
  
  // Actions
  setMobile: (isMobile: boolean) => void;
  setActivePage: (page: string) => void;
  toggleCollapse: () => void;
}

export const useNavigationStore = create<NavigationState>()(
  persist(
    (set) => ({
      isMobile: false,
      isCollapsed: false,
      activePage: 'rooms',
      
      setMobile: (isMobile: boolean) => set({ isMobile }),
      setActivePage: (activePage) => set({ activePage }),
      toggleCollapse: () => set((state) => ({ isCollapsed: !state.isCollapsed })),
    }),
    {
      name: 'navigation-storage',
      partialize: (state) => ({ 
        isCollapsed: state.isCollapsed,
        activePage: state.activePage 
      }),
    }
  )
);
